export const WHATSAPP_CONTACT_LINK =
  "https://wa.me/554199875680?text=Oii%2C%20gostaria%20de%20falar%20com%20a%20equipe%20do%20Secrets.";

export const WHATSAPP_FORGOT_TOKEN_LINK =
  "https://wa.me/5541996649415?text=Oi%2C%20perdi%20meu%20Codigo%20Secrets%20da%20lista.%20Pode%20me%20ajudar%3F";

export const WHATSAPP_GROUP_LINK =
  "https://chat.whatsapp.com/Dfe6jLtds1W1i2zI4CK1gK";
